export default class InviteUsersController {
	constructor(PermissionsService, ContentService, AuthService, $validation, $translate) {
		this.permsService = PermissionsService;
		this.service = ContentService;
		this.auth = AuthService;
		this.validation = $validation;
		this.trans = $translate.instant;
	}

	$onInit() {
		this.subscriptions = [];

		const _ = this.trans;
		this.validation.setExpression({
			multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/			
		}).setDefaultMsg({
			multiemail: {
				error: _("No es un correo o listado de correos válido")
			}
		});
		this.permslist = {};
		this.subscriptions.push(
			this.permsService.getPermissions().subscribe(
				(permissions) => {
					this.permslist = permissions;
				}
			)
		);
		this.currentProfile = this.auth.getProfile();
	}
	$onDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	inviteUser(){
		const perms = this.permslist.filter(perm => perm.enabled).map(perm => perm.perm)
		this.subscriptions.push(
			this.service.inviteUser(this.emails, perms).subscribe(
				() => { this.emails = null;  this.permslist.forEach(p => p.enabled = false);}	
			)
		);
	}
}

InviteUsersController.$inject = ['PermissionsService', 'ContentService', 'AuthService', '$validation', '$translate'];



// WEBPACK FOOTER //
// ./src/app/pages/invite-users/invite-users.controller.js